import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { FormItemDescription } from "../../components/antd/form/FormItemDescription";
import { Identity } from "../../schema/types/identity/entity";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { linksOf } from "../../services/cpln";
import { FormItem } from "../../components/antd/form/FormItem";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { FormItemValue } from "../../components/antd/form/FormItemValue";
import { CopyButtonWithApproval } from "../domain/create/copyButtonWithApproval";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpLabelDirtyIndicator } from "../gvc/testNewForm/CpLabelDirtyIndicator";
import { CpTextArea } from "../gvc/testNewForm/CpTextArea";
import { parseLink } from "../../utils/linkParser/linkParser";

interface Props {
  identity: Identity;
}
export const Summary: React.FC<Props> = ({ identity }) => {
  const selfLink = linksOf(identity).self!;
  const gvcName = parseLink(selfLink, { useInputCtx: true }).gvc;

  const hasTagLinks =
    Object.entries(identity.tags || {}).filter(([_, value]) =>
      tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)),
    ).length > 0;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`description`}>
                <FormLabel>Description</FormLabel>
                <CpLabelDirtyIndicator name={`description`} />
              </CpLabel>
              <CpTextArea autoSize name={`description`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`description`} />
            </CpFormItem>
            <FormItem>
              <FormLabel>GVC</FormLabel>
              <FormItemValue>{gvcName}</FormItemValue>
            </FormItem>
            {identity.status?.objectName ? (
              <>
                <FormItem lastItem={!hasTagLinks}>
                  <FormLabel>Object Name</FormLabel>
                  <FormItemDescription>
                    This is the object this identity creates in your cloud account.
                  </FormItemDescription>
                  <div className="flex items-center gap-2">
                    <FormItemValue>{identity.status.objectName}</FormItemValue>
                    <CopyButtonWithApproval value={identity.status.objectName} />
                  </div>
                </FormItem>
              </>
            ) : null}
            {hasTagLinks ? (
              <TagLinksTable
                tableId="identity-info-tag-links"
                tags={Object.entries(identity.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
